import { render, staticRenderFns } from "./ImportTemplate.vue?vue&type=template&id=20dc721e"
import script from "./ImportTemplate.vue?vue&type=script&lang=js"
export * from "./ImportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports